module.exports = __webpack_public_path__ + "static/media/stopDrop.07e439b8.png";